module.exports = __webpack_public_path__ + "img/table.3a51a574.svg";